import type { JournalArticle } from '~/utils/solr/journal'

type JournalArticleType = NonNullable<JournalArticle['articleType']>[number]

export interface AbstractData {
  title?: string | null
  abstractText: string
}

export function getJournalArticleTypeLabel(articleType?: JournalArticleType | null): string | null {
  switch (articleType) {
    case 'editorial':
      return 'Leder'
    case 'research-article':
      return 'Vitenskapelig publikasjon'
    case 'review-article':
      return 'Oversiktsartikkel'
    case 'book-review':
      return 'Bokomtale'
    case 'discussion':
      return 'Diskusjon'
    case 'bibliography':
      return 'Bibliografi'
    default:
      return null
  }
}

export function getJournalAbstractData(article?: JournalArticle | null): AbstractData | null {
  const abstractText = article?.abstract?.trim()
  if (!abstractText) {
    return null
  }

  return {
    title: 'Sammendrag',
    abstractText,
  }
}
